import React from 'react'
import { Select } from 'antd'
import { useSelectedWeek } from '../../contexts/SelectedWeekContext'
interface Week {
  label: string
  value: string
}

interface WeekSelectProps {
  selectedWeek: string
  setSelectedWeek: React.Dispatch<React.SetStateAction<string | null>>
}

const generateWeeks = (): Week[] => {
  const startDate = new Date('September 1, 2025')
  const endDate = new Date('June 30, 2026')
  const weeks: Week[] = []

  let weekNumber = 36
  let currentYear = startDate.getFullYear()

  while (startDate <= endDate) {
    const weekStart = new Date(startDate)
    const weekEnd = new Date(startDate)
    weekEnd.setDate(weekEnd.getDate() + 6)

    const weekLabel = `Week ${weekNumber}/${currentYear} (${formatDate(weekStart)} - ${formatDate(
      weekEnd
    )})`
    const weekValue = `${currentYear}-W${weekNumber}`

    weeks.push({ label: weekLabel, value: weekValue })

    startDate.setDate(startDate.getDate() + 7)
    weekNumber++

    if (weekNumber > 52) {
      weekNumber = 1
      currentYear++
    }
  }

  return weeks
}

const formatDate = (date: Date): string => {
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
}

const WeekSelect: React.FC = () => {
  const weeks = generateWeeks()
  const defaultWeek = weeks.find((week) => week.label.includes('Week 37'))
  const { selectedWeek, setSelectedWeek } = useSelectedWeek('2025-W40')
  function onChangeSelect(value): void {
    setSelectedWeek(value)
  }

  return (
    <Select
      variant='borderless'
      className='border border-gray-500 border-3 rounded'
      size={'large'}
      placeholder='Select a week'
      defaultValue={defaultWeek?.value}
      value={selectedWeek}
      onChange={onChangeSelect}
    >
      {weeks.map((week) => (
        <Select.Option key={week.value} value={week.value}>
          {week.label}
        </Select.Option>
      ))}
    </Select>
  )
}

export default WeekSelect
